<template>
    <div v-if="loading">
        <vx-card>
            <h3> Loading... Please wait...</h3>
        </vx-card>
    </div>
    <vx-card v-else>
        <div class="vx-row">
            <div class="vx-col w-full mb-3">
                <vs-input
                    class="w-full" 
                    label="Portfolio Name" 
                    placeholder="Enter name of the Portfolio" 
                    v-model="portfolio.name"
                    :warning="api_errors.name"
                    :warning-text="api_errors.name?api_errors.name[0]:null"
                />
            </div>
            <div class="vx-col w-full mb-3">
                <SelectForeign
                    :model.sync="portfolio.entity"
                    label="Entity"
                    placeholder="Type to Search"
                    :multiple="false"
                    :load_initial="true"
                    :label_keys="['name', ]"
                    label_class="mb-0"
                    input_class="mt-0"
                    :show_id_in_label="true"
                    :endpoint="$store.state.apiendpoints.entity_list"
                    :warning="api_errors.entity"
                    :warning_text="api_errors.entity ? api_errors.entity.join(',') : null"
                    :use_id_as_value="false"
                    list_length="10000"
                />
            </div>
            <div class="vx-col w-full mt-3 text-center">
                <vs-button 
                    color="primary" 
                    type="filled" 
                    @click.prevent="save"
                    :disabled="submit_disabled"
                >Save</vs-button>
            </div>
        </div>
    </vx-card>
</template>

<script>

import {Request} from "../../utils/requests"

export default {
    data() {
        return {
            loading: true,

            portfolio: {
                name: null,
                entity: null,
            },
            portfolio_id: this.$route.params.portfolio_id,
            submit_disabled: false,
            api_errors: {}
        }
    },
    mounted() {
        this.init()
    },
    watch: {
        '$route.params.portfolio_id'(newV) {
            this.init()
        }
    },
    methods: {
        init() {
            this.portfolio_id = this.$route.params.portfolio_id
            if(this.portfolio_id){
                this.loadData()
            } else { 
                this.loading = false
                this.portfolio = {
                    name: null,
                    entity: null,
                }
            }
        },
        loadData() {
            this.loading = true
            this.$vs.loading()

            let url = this.$store.state.apiendpoints.portfolio + this.portfolio_id + "/"

            Request(this, 'GET', url).then(
                (res) => { 
                    this.portfolio = res
                    this.loading = false
                    this.$vs.loading.close()
                },
                (err) => {
                    this.$vs.notify({
                        time: 2500,
                        title: 'Unknown Error',
                        text: 'An Error Occured while loading data. Please Try Again',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                    this.loading = false
                    this.$vs.loading.close()
                    this.$router.push("/")
                }
            )
        },
        save(){
            let $this = this
            let url = $this.$store.state.apiendpoints.portfolio, request_method = 'POST'

            if(this.portfolio_id){
                url += this.portfolio_id + "/"
                request_method = 'PUT'
            }

            let data = {...this.portfolio}

            this.submit_disabled = true

            Request($this, request_method, url, null, data).then( 
                (res) => {
                    $this.$vs.notify({
                        time: 2500,
                        title: 'Saved',
                        text: 'Saved Successfully',
                        iconPack: 'feather',
                        icon: 'icon-check',
                        color: 'success'
                    })
                    this.submit_disabled = false
                    $this.$router.push({name: 'portfolio-list'})
                },
                (err) => {
                    if(err.error) {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: 'Please check all fields and Try Again.',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                        this.api_errors = err.error
                    } else {
                        $this.$vs.notify({
                            time: 2500,
                            title: 'Unknown Error',
                            text: 'An Error Occured. Please Try Again',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                    this.submit_disabled = false
                }
            )
        }
    }
}
</script>